import React, { useState } from "react";
import "./ManualDepositPopup.css";
import QrManualDeposit from "./QrManualDeposit"; // Import the QR popup
import { IoChevronBackSharp } from "react-icons/io5";
import Storage from "../../../Storage";
function ManualDepositPopup({ isOpen, onClose }) {
  const [amount, setAmount] = useState("");
  const [qrManualDepositVisible, setQrManualDepositVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // Error message state

  if (!isOpen) return null;

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);

    // Agar input blank ho, error hide ho jaye
    if (value === "") {
      setErrorMessage("");
      return;
    }

    // Live validation on every change
    if (value < 5) {
      setErrorMessage("Please enter minimum amount 5 USDT");
    } else {
      setErrorMessage(""); // Clear error if valid
    }
  };

  const handleSubmit = () => {
    if (!amount || amount <5) {
      setErrorMessage("Please enter minimum amount 5 USDT"); // Show error message
      return;
    }
    setErrorMessage(""); // Clear error if valid
    setQrManualDepositVisible(true); // Open the QR popup with amount
  };

  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        <div className="vip2-popup-page" style={{ background: "#323738" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />
          </div>
          Manual Method
        </div>
        <div
          className="main-int-overflow-sroll"
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0px 0px 10px 10px ",
          }}
        >
          <div
            style={{
              background: "#323738",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }} className="main-int-uew-1235">
              <div className="main-int-uew-1236">Deposit Currency</div>
              <div className="main-int-uew-1237">
                <img
                  className="main-int-uew-1238"
                  src="/assets/bcimages/USDT.png"
                  alt="USDT"
                />
                <div>{Storage?.getKey("currency")}</div>
              </div>
            </div>
            <div className="main-int-uew-new-1">Manual Deposit</div>
            <div className="popup-body-inner-main-543">
              <div
                style={{ textAlign: "start" }}
                className="amount-input-inner-main-543"
              >
                <img style={{ width: "60px" }} src="/assets/images/USDT.png" />
              </div>
            </div>

            <div
              style={{
                margin: "20px 0px",
                background: "#514634",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "10px",
              }}
            >
              <img
                style={{ width: "50px" }}
                src="/assets/images/bonus-gift.webp"
              />
              <div style={{ fontWeight: "bold", textAlign: "start" }}>
                Get extra <span style={{ color: "#FF9820" }}>180%</span> bonus
                on minimum of{" "}
                <span style={{ color: "#FF9820" }}>$1,056.84</span> deposit
              </div>
            </div>

            <div className="main-int-uew-new-1">5 - 50,000 USDT</div>
            {/* Error Message (Only Visible if Amount is Less Than 300) */}

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={handleAmountChange} // Validate amount in real-time
              />
              {errorMessage && (
                <div className="error-message-main-error-inr">
                  {errorMessage}
                </div>
              )}
              <button
                className="submit-button-inner-main-543"
                onClick={handleSubmit}
              >
                Process To Submit
              </button>
            </div>

            <div
              className="deposit-rules-text-12"
              style={{ background: "#314940", color: "#B3BEC1" }}
            >
              <div>
                1. Your transfer amount has to MATCH the submission amount.
              </div>
              <div>
                2. Each Order ID can ONLY be used once to avoid duplicates.
              </div>
              <div>
                3. Please follow the deposit guideline to make deposit,
                otherwise your deposit will be missing.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Show the QR popup */}
      <QrManualDeposit 
        isOpen={qrManualDepositVisible}
        onClose={() => setQrManualDepositVisible(false)}
        amount={amount}
      />
    </div>
  );
}

export default ManualDepositPopup;
